var l;
((e) => {
  function n(r = 1) {
    return `calc(var(--quant) * ${r})`;
  }
  e.q = n;
  function o(r = "normal") {
    return `var(--offset-${r})`;
  }
  e.offset = o;
  function f(r = "normal") {
    return `var(--font-size-${r})`;
  }
  e.fontSize = f;
  function a(r = "normal") {
    return `var(--border-radius-${r})`;
  }
  e.borderRadius = a;
  function $(r, u, i = 1) {
    let t = u;
    return t === "pure" && (t = ""), typeof t == "number" && (t = `${t}`), `rgba(var(--color-${r}${t ? `-${t}` : ""}), ${i})`;
  }
  e.color = $, ((r) => {
    r.fullWidth = "util-full-width", r.fullHeight = "util-full-height", r.flexGrow = "util-flex-grow", r.flexNoShrink = "util-flex-no-shrink", r.userSelectableText = "util-text-selectable", r.zIndex9000 = "util-z-index-9000";
  })(e.cls || (e.cls = {})), e.pc = (r) => `${r}%`, e.px = (r) => `${r}px`, e.ch = (r) => `${r}ch`, e.em = (r) => `${r}em`, e.rem = (r) => `${r}rem`, e.vh = (r) => `${r}vh`, e.vw = (r) => `${r}vw`, e.url = (r) => `url(${r})`;
})(l || (l = {}));
export {
  l as ui
};
